import React from 'react';

interface SidebarBackdropProps {
  isVisible: boolean;
  onClick: () => void;
}

const SidebarBackdrop: React.FC<SidebarBackdropProps> = ({ isVisible, onClick }) => {
  return (
    <div
      className={`sidebar-backdrop${isVisible ? ' sidebar-backdrop--visible' : ''}`}
      onClick={onClick}
      aria-hidden="true"
    />
  );
};

export default SidebarBackdrop;
